import { BaseParams, BaseParamsInterface } from '@app/store/models';
import { CustomersValue } from './customers.value';

interface ParamsType extends BaseParamsInterface {
    //
}

export class CustomersValueDto extends BaseParams {
    private _params: ParamsType;

    constructor(dto: CustomersValue) {
        super(dto);

        this._params = { ...this.baseParams };
    }

    get params(): Record<string, string> {
        return Object.fromEntries(Object.entries(this._params).filter(([, value]) => value !== undefined && value !== null));
    }
}
